<label class="typo-bart mb-1 block" [for]="htmlId"> <ng-content></ng-content><span *ngIf="isRequired">&nbsp;*</span> </label>
